import { Binoculars } from "@phosphor-icons/react"
import { ChartWithConfigId } from "@tokenterminal/core/feature/chart/ChartWithConfigId"
import { ChartContextProvider } from "@tokenterminal/core/feature/chart/tt-ui-chart/ChartContext"
import { ErrorBoundary } from "@tokenterminal/core/ui/ErrorBoundary"
import { ClientOnlySuspense } from "@/components/ClientOnlySuspense"
import { PRODUCTS } from "@/constants/urls"
import { FADE_MASK_STYLE } from "@/utils/masonryMask"
import { MasonryWidget } from "./MasonryWidget"

const CHART_ID = "ZDVhMWFmNjBhMmY1NDMzODU2MTE1YjQx"

export function MasonryChartWidget() {
  return (
    <MasonryWidget
      href={PRODUCTS.EXPLORER_ROUTE}
      icon={Binoculars}
      productName="Explorer"
      widgetName="Historical onchain metrics"
      description="Track blockchain fees, revenue, and other key metrics over time with interactive charts that let you compare performance across projects and chains."
      desktopLayout="row"
      featuredVisual={
        <div style={{ overflow: "hidden", ...FADE_MASK_STYLE }}>
          <div className="bg-bg-surface border border-solid border-border-default rounded-tl-xl p-5 w-[800px]">
            <div className="pb-2">
              <h3 className="text-sm font-medium text-fg-default">Fees for L1 blockchains</h3>
            </div>
            <div className="flex-1 w-full min-h-0 h-[420px]">
              <ErrorBoundary fallback={null}>
                <ClientOnlySuspense>
                  <ChartContextProvider>
                    <ChartWithConfigId
                      id={CHART_ID}
                      isVisible
                      showDescription={false}
                      showTitle={false}
                      disableClickToOpenModal
                    />
                  </ChartContextProvider>
                </ClientOnlySuspense>
              </ErrorBoundary>
            </div>
          </div>
        </div>
      }
    />
  )
}
